module.exports = __webpack_public_path__ + "static/media/icon_160.389a1041.svg";